var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    zoomAndPan: "magnify",
    viewBox: "0 0 52.5 52.499999",
    height: 70,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "efc7df8cb2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.890625 0.890625 L 49.925781 0.890625 L 49.925781 49.925781 L 0.890625 49.925781 Z M 0.890625 0.890625 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#efc7df8cb2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M 25.546875 0.886719 C 11.941406 0.886719 0.886719 11.941406 0.886719 25.546875 C 0.886719 39.152344 11.941406 50.207031 25.546875 50.207031 C 39.152344 50.207031 50.207031 39.152344 50.207031 25.546875 C 50.207031 11.941406 39.152344 0.886719 25.546875 0.886719 Z M 25.546875 3.355469 C 37.820312 3.355469 47.742188 13.273438 47.742188 25.546875 C 47.742188 37.820312 37.820312 47.742188 25.546875 47.742188 C 13.273438 47.742188 3.355469 37.820312 3.355469 25.546875 C 3.355469 13.273438 13.273438 3.355469 25.546875 3.355469 Z M 25.644531 8.195312 L 25.550781 9.421875 L 24.265625 26.144531 L 33.460938 32.714844 L 34.46875 33.429688 L 35.898438 31.421875 L 34.894531 30.710938 L 26.828125 24.949219 L 28.007812 9.613281 L 28.105469 8.382812 Z M 25.644531 8.195312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/timeIcon.71a7dd1c3d281063030e8efd34667c01.svg";
export { ForwardRef as ReactComponent };